import type { ComponentProps } from "react";

import { cn } from "shared/utils/cn";

import { Field } from "./field";

type Props = {
  inputClassName?: string;
  error?: string;
};

export const Input = (props: ComponentProps<"input"> & Props) => {
  const { className, error, inputClassName, children, ...inputProps } = props;
  return (
    <Field
      className={cn(
        "h-12.5 p-0 focus-within:border-white",
        error && "border-pale-red!",
        className
      )}
    >
      <input
        className={cn(
          "placeholder:text-pale-grey h-full w-full px-3 leading-5.5 tracking-[0.4px] text-white outline-hidden",
          inputClassName
        )}
        {...inputProps}
      />

      {children && (
        <div className="absolute top-1/2 right-3 flex -translate-y-1/2">
          {children}
        </div>
      )}

      {error && (
        <div className="text-pale-red absolute top-full left-0 flex w-full translate-y-0.5 text-xs">
          {error}
        </div>
      )}
    </Field>
  );
};
